/* ============================================================
   Notifications redesign — UI copy
   ------------------------------------------------------------
   Net-new copy introduced by the redesign (lead, legend, lock
   affordance, default tag). Category and universal tooltip text is
   intentionally NOT here — it is sourced from the existing
   category/setting definitions in the view components.
   ============================================================ */

// Panel lead. The "Changes save automatically" sentence is omitted because
// the page ships in explicit-Save (button) mode. The non-breaking space keeps
// the final "get it." together so "it." never orphans onto its own line.
export const NOTIFICATIONS_LEAD =
  'Choose which roles receive each type of notification, and how they get it.';

// Below-table legend explaining the locked Account Owner cells.
export const NOTIFICATIONS_LEGEND =
  'Required — the Account Owner always receives a category until another role is enrolled.';

// Tooltip shown on a locked Account Owner cell.
export const OWNER_LOCK_TOOLTIP =
  'The Account Owner always receives this so at least one recipient is enrolled. ' +
  'Turn it on for another role to unlock.';

// Pill tag rendered next to the Account Owner (the guaranteed recipient).
export const DEFAULT_ROLE_TAG = 'Default';
